import React from "react";
import styled from "styled-components/macro";
import { Helmet } from "react-helmet-async";
import {
  Breadcrumbs as MuiBreadcrumbs,
  Divider as MuiDivider,
  Typography,
} from "@material-ui/core";
import Link from "@material-ui/core/Link";
import { NavLink } from "react-router-dom";
import { spacing } from "@material-ui/system";

const Container = styled.div`
  width: 100%;
  height: calc(100vh - 64px - 48px - 106px - 48px - 64px);
  position: relative;
`;

const Divider = styled(MuiDivider)(spacing);
const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const PlantFlows = () => {
  return (
    <>
      <Helmet title="Plant Flow Report Spreadsheet" />
      <Typography variant="h3" gutterBottom display="inline">
        Plant Flow Report Spreadsheet
      </Typography>

      <Breadcrumbs aria-label="Breadcrumb" mt={2}>
        <Link component={NavLink} exact to="/dashboard">
          Dashboard
        </Link>
        <Typography>Plant Flow Report Spreadsheet</Typography>
      </Breadcrumbs>

      <Divider my={6} />

      <Container>
        <iframe
          src="https://docs.google.com/spreadsheets/d/1fyRaHqt-Wnxptsbl6rhbXdk4APKlKiXpUc46l6Li6kI/edit?usp=sharing&range=MikesSheetINPUTs!A2:H15&rm=minimal&headers=false&widget=false&single=true&chrome=false&"
          width="100%"
          height="100%"
          frameBorder="0"
          scrolling="no"
          title="Plant Flow Report Spreadsheet"
        />
      </Container>
    </>
  );
};

export default PlantFlows;
